<template>
  <div class="pl-5 pr-5">
    <p class="mb-0 pt-4">{{ $t(text) }}</p>
    <div class="row d-flex justify-content-between pb-4 mt-4 ml-4 mr-4">
      <div class="col flex-grow pl-2">
        <Button :title="$t('Ok')" buttonClass='save-button semi-bold w-100' @onClick="confirm" />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button'

export default {
  emits: ['confirm', 'cancel'],
  props: {
    text: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm');
    }
  },
  components: {
    Button
  },
}
</script>



// WEBPACK FOOTER //
// src/components/InfoConfirm.vue